<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        Gadchiroli District Badminton Championship
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
       <div class="sec-title text-center mb-5">
          <h2><span> G H Raisoni Memorial Gadchiroli District Badminton Championship 2025 </span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-7">
                <p>
                    <strong>Dates:</strong> 6th - 8th June
                </p>
                <p>
                    <strong>Venue:</strong> Recreation Badminton Hall, Near LIC Office, District Sports Office Complex, Gadchiroli
                </p>
                <h6>Events Categories:</h6>

                <ul class="list-style list-style1  mb-3 ">
                  <li> 1. Under 11 Singles Girls & Boys </li>
                  <li> 2. Under 13 Singles Girls & Boys</li>
                  <li> 3. Under 15 Singles Girls & Boys</li>
                  <li> 4. Under 17 Singles Girls & Boys</li>
                  <li>5. Under 19 Singles Girls & Boys</li>
                  <li> 6. Open Category: Men's Singles, Women's Singles, Men's Doubles, Women's Doubles </li>
                </ul>

                <h6 class="mt-4">Note:</h6>
                <ul class="list-style list-style1  mb-3 ">
                    <li>1. Last Date of Entry: 4th June 2025</li>
                    <li>2. A Player Can Participate in Maximum of 3 Events</li>
                    <li>3. This Tournament is Selection Tournament for U17, U19 & Senior Category for Upcoming Inter District State Badminton CHampionship 2025</li>
                </ul>
                <h6 class="mt-4">For Queries, Contact: </h6>
                <ul class="list-style list-style1  mb-3 ">
                    <li>1. Madhukar Michha: <a href="tel:9420689040">9420689040</a></li>
                    <li>2. Lomesh Leangure: <a href="tel:9421815138">9421815138</a></li>
                    <li>3. Nakul randive: <a href="tel:8262961752">8262961752</a></li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/gadchiroli-district-badminton-championship.webp" alt="GHRSCF">
                </div>
            </div>
        </div>
    </div>
</section>

